import { deepMerge } from "@antfu/utils"
import { createVuetify } from "vuetify"
import { VBtn } from "vuetify/components/VBtn"
import defaults from "./defaults"
import { icons } from "./icons"
import { staticPrimaryColor, themes } from "./theme"
import { fa } from "vuetify/locale"

// Styles
import { cookieRef } from "@/@layouts/stores/config"
import "@core/scss/template/libs/vuetify/index.scss"
import "vuetify/styles"

export default defineNuxtPlugin((nuxtApp) => {
  const cookieThemeValues = {
    // defaultTheme: resolveVuetifyTheme(),
    themes: {
      light: {
        colors: {
          primary: cookieRef("lightThemePrimaryColor", staticPrimaryColor)
            .value,
        },
      },
      dark: {
        colors: {
          primary: cookieRef("darkThemePrimaryColor", staticPrimaryColor).value,
        },
      },
    },
  }

  const optionTheme = deepMerge({ themes }, cookieThemeValues)

  const vuetify = createVuetify({
    locale: {
      locale: "fa",
      fallback: "en",
      messages: { fa },
    },
    ssr: true,
    aliases: {
      IconBtn: VBtn,
    },
    defaults,
    icons,
    theme: optionTheme,
  })

  nuxtApp.vueApp.use(vuetify)
})
